"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
class ConsoleLogger {
    constructor(namespace) {
        this.log = (message) => {
            // eslint-disable-next-line no-console
            console.log("[coach-app-shared-components] [" + this.namespace + "] " + message);
        };
        this.warn = (message) => {
            // eslint-disable-next-line no-console
            console.warn("[coach-app-shared-components] [" + this.namespace + "] " + message);
        };
        this.error = (error) => {
            // eslint-disable-next-line no-console
            console.warn("[coach-app-shared-components] [" +
                this.namespace +
                "] " +
                error.message +
                ". Check exact error");
            // eslint-disable-next-line no-console
            console.error(new exception_1.RuntimeException(error.message, error));
        };
        this.namespace = namespace;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    debug(message, context) {
        // eslint-disable-next-line no-console
        console.log("[coach-app-shared-components] [" + this.namespace + "] " + message, context);
    }
}
exports.default = ConsoleLogger;
//# sourceMappingURL=ConsoleLogger.js.map